import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAppDispatch } from "../../../redux/hooks";
import { resolveScopedVaultApi } from "../../../api/vault.api";
import { vaultKeys } from "../queryKeys";
import { setActiveRequirement } from "../../../redux/slices/vaultSlice";
import { setActiveRequirement as setAdminActiveRequirement } from "../../../redux/slices/requirementsSlice";
import { getExceptionMessage } from "../../../exceptions/helpers/getExceptionMessage";
import { vaultExceptions } from "../../../exceptions/default/vaultExceptions";

export function useCancelToReview(folderId: string | undefined) {
  const queryClient = useQueryClient();
  const dispatch = useAppDispatch();
  const scopedVaultApi = resolveScopedVaultApi(
    typeof window !== "undefined" ? window.location.pathname : "",
  );

  return useMutation({
    mutationFn: async (reqId: string) => {
      try {
        return await scopedVaultApi.cancelToReview(reqId);
      } catch (error: any) {
        throw new Error(getExceptionMessage(error.response?.data?.code, vaultExceptions.onCancelRequirementVaultToReview));
      }
    },
    onSuccess: async (data) => {
      await queryClient.invalidateQueries({
        queryKey: vaultKeys.folder(folderId ?? ""),
      });
      dispatch(setActiveRequirement(data));
      dispatch(setAdminActiveRequirement(data));
    },
  });
}
